import { render, staticRenderFns } from "./handgrader_roster.vue?vue&type=template&id=14d132bb&scoped=true&"
import script from "./handgrader_roster.vue?vue&type=script&lang=ts&"
export * from "./handgrader_roster.vue?vue&type=script&lang=ts&"
import style0 from "./handgrader_roster.vue?vue&type=style&index=0&id=14d132bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d132bb",
  null
  
)

export default component.exports